/* SPECIFIC JS FOR THE VIEW IF NEEDED */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = intro;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _domClasslist = require('dom-classlist');

var _domClasslist2 = _interopRequireDefault(_domClasslist);

var _pubsub = require('pubsub');

var _pubsub2 = _interopRequireDefault(_pubsub);

var _scrollmagic = require('scrollmagic');

var _scrollmagic2 = _interopRequireDefault(_scrollmagic);

var _swiper = require('swiper');

var _swiper2 = _interopRequireDefault(_swiper);

require("scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap");

var _xhr = require('xhr');

var _xhr2 = _interopRequireDefault(_xhr);

function intro() {
  var self = this,
      intro = document.querySelector('.intro');

  if (!intro) {
    return;
  }

  var _rub = document.querySelector('.b4s3_home'),
      video = document.querySelector('video');

  function addListeners() {
    _pubsub2['default'].on('resize', resize);
  }

  function resize(winW, winH) {
    console.log('HOME resize > script/wiews/b4s3_home.js');
  }

  function initIntro() {
    document.querySelector('.toggle-sound').addEventListener('click', function () {
      this.classList.toggle('active');
      video.muted = !video.muted;
    });

    video.addEventListener('ended', function () {
      TweenMax.to(document.querySelector('.intro'), 1, {
        autoAlpha: 0
      });
      /*TweenMax.to(document.body, 1, {
        autoAlpha: 0,
        onComplete: function () {
          //document.location.href = '/'
        }
      })*/
    });

    video.addEventListener('timeupdate', function (e) {
      if (this.currentTime > this.duration - 3) {
        TweenMax.to(video, 2, {
          volume: 0
        });
      }
    });

    document.querySelector('.skip').addEventListener('click', function (e) {
      e.preventDefault();

      /*TweenMax.to(document.body, 1, {
        autoAlpha: 0
      })*/

      TweenMax.to(document.querySelector('.intro'), 1, {
        autoAlpha: 0
      });
      TweenMax.to(video, 0.5, {
        autoAlpha: 0
      });
      TweenMax.to(video, 2, {
        volume: 0,
        onComplete: function onComplete() {
          //document.location.href = '/'
        }
      });
    });
  }

  (function init() {
    initIntro();
  })();
}

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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